import React, {useEffect, useState} from "react";
import {Avatar, Badge, Button, Col, Divider, Drawer, Dropdown, Layout, Menu, Row, Switch,} from "antd";
import {useRecoilState, useRecoilValue} from "recoil";
import {
    globalBrandSettingState,
    globalColorThemeState,
    globalEWalletSummaryState,
    globalLanguageListState,
    globalOpenGoLiveModalState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState,
    globalUserDetailState,
} from "../../../_common/global_state";
import {DownloadOutlined} from "@ant-design/icons";
import QrModal from "./qr/qrModal";
import {truncateString, useIsMobile} from "../../../_common/function";
import PlatformDownloadModal from "./platformDownload/platformDownloadModal";
import {getPlatform} from "../../../api/graphql/platformDownload";
import dummyImg from "../../../assets/image/dummy.png";
import {useNavigate} from "react-router-dom";
import useShared from "../../../_common/_shared";
import {useTranslation} from "react-i18next";
import GoLiveModal from "./goLive";
import {useVerification} from "../../../_common/_authorize";
import useLayoutFunction from "../../function";
import {getUserAnnouncementUnreadCount} from "../../../api/graphql/announcement";
import Announcement_2 from "../../../pages/announcement/view/layout_2";

const {Header} = Layout;

export const Header_2 = (props) => {
    const {registerField} = props;
    const {t} = useTranslation();
    const navigate = useNavigate();
    const isMobile = useIsMobile(796)
    const {IconCommon, formatCurrency} = useShared();
    const {changeLanguageHandler, filterAndGroupServers} = useLayoutFunction()
    const {handleTokenExpiration} = useVerification();

    const [openQrModal, setOpenQrModal] = useState(false);
    const [openPlatformModal, setOpenPlatformModal] = useState(false);
    const [platformData, setPlatformData] = useState([]);
    const [open, setOpen] = useState(false);

    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useRecoilState(globalUnreadAnnouncementCountState);
    const [colorState, setColorState] = useRecoilState(globalColorThemeState);
    const [openGoLiveModal, setOpenGoLiveModal] = useRecoilState(globalOpenGoLiveModalState);
    const unreadPushNotificationCount = useRecoilValue(globalUnreadPushNotificationCountState);
    const userDetails = useRecoilValue(globalUserDetailState);
    const brandSettingState = useRecoilValue(globalBrandSettingState);
    const languageListState = useRecoilValue(globalLanguageListState);
    const eWalletSummary = useRecoilValue(globalEWalletSummaryState);

    const userId = localStorage.getItem("userid")

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const preload = async () => {
        try {
            const unreadCount = await getUserAnnouncementUnreadCount(userId);
            setUnreadAnnouncementCount(unreadCount?.getUserAnnouncementByUserId?.unreadTotal);

            const response = await getPlatform();
            const filtered = filterAndGroupServers(response?.getPlatform?.data);
            setPlatformData(filtered);
        } catch (e) {
            console.error(e)
        }
    };

    useEffect(() => {
        preload();
    }, []);

    const dropdownItems = (
        <Menu className={"headerDetails"}>
            <Menu.Item key={"1"}>
                {t("common.hello")}, <strong>{userDetails?.username}</strong>
            </Menu.Item>
            <Menu.Item key={"2"}>
                <strong>{t("user.rank")}:</strong> {userDetails?.rank?.name || "-"}
            </Menu.Item>
            <Menu.Item key={"4"}>
                <strong>{t("user.email")}:</strong>{" "}
                {truncateString(userDetails?.email || "", 30)}
            </Menu.Item>
            <Menu.Item key={"5"}>
                <strong>{t("user.mobileNo")}:</strong>{" "}
                {truncateString(userDetails?.completedMobileNo || "", 30)}
            </Menu.Item>
            <Divider style={{margin: "0.3rem 0", background: "var(--divider-color)"}}/>
            <Menu.Item key={"6"}>
                <a onClick={() => navigate("/profile")}>
                    <IconCommon className={"headerIcon"} iconName={"edit"}/>
                    {t("common.editProfile")}
                </a>
            </Menu.Item>
            <Divider style={{margin: "0.3rem 0", background: "var(--divider-color)"}}/>
            <Menu.Item key={"7"}>
                <a onClick={() => handleTokenExpiration(true)}>
                    <IconCommon className={"headerIcon"} iconName={"logout"}/>
                    {t("common.logOut")}
                </a>
            </Menu.Item>
        </Menu>
    );

    const languageDropdown = (
        <Menu
            className={"headerLanguage"}
            selectedKeys={[localStorage.getItem("language")]}
        >
            {(languageListState ?? [])?.map((lang) => (
                <Menu.Item
                    key={lang?.code}
                    value={lang?.code}
                    onClick={() => changeLanguageHandler(lang?.code)}
                >
                    {lang?.nativeName}
                </Menu.Item>
            ))}
        </Menu>
    );

    const currentLanguageObj = languageListState?.find((lang) => lang?.code === localStorage.getItem("language"));

    return (
        <Header id={"layout-header"}>
            {isMobile ? (
                <>
                    <div className={"flex *:px-3"} id={"header-row"}>
                        <Col className={"text-center !w-3/12 flex-none"}>
                            <img
                                alt={"logo"}
                                className={"cursor-pointer"}
                                onClick={() => navigate("/dashboard")}
                                height={37}
                                src={colorState === "dark" ? brandSettingState?.companyLogoInverse : brandSettingState?.companyLogo}
                            />
                        </Col>
                        <Col className={"text-center flex items-center !w-9/12 flex-none justify-end"}>
                            <Dropdown
                                trigger={["click"]}
                                overlay={<Announcement_2 isHeader/>}
                                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                placement={"bottom"}
                            >
                                <div className={"header-announcement"}>
                                    <Badge count={unreadAnnouncementCount + unreadPushNotificationCount} size={"small"}>
                                        <IconCommon
                                            className={"sidebarIcon cursor-pointer"}
                                            iconName={"alert"}
                                        />
                                    </Badge>
                                </div>
                            </Dropdown>
                            <Button className={"navbar-toggler-layer"} onClick={handleDrawerOpen}>
                                <span className={"navbar-toggler-icon"}/>
                            </Button>
                        </Col>
                    </div>
                    <Drawer
                        getContainer={() => document.getElementById("layout-2")}
                        title={
                            <>
                                <Dropdown
                                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                    overlay={languageDropdown}
                                    id={"language-select"}
                                >
                                    <a onClick={(e) => e?.preventDefault()}>
                                        {currentLanguageObj?.nativeName}
                                    </a>
                                </Dropdown>
                                <Divider type={"vertical"} className={"headerDivider"}/>
                                <Switch
                                    checked={colorState === "light"}
                                    checkedChildren={
                                        <IconCommon
                                            isAlwaysActive
                                            iconName={"sun"}
                                            className={"switchIcon"}
                                        />
                                    }
                                    unCheckedChildren={<IconCommon iconName={"moon"} className={"switchIcon"}/>}
                                    onChange={(e) => {
                                        if (e) {
                                            setColorState("light");
                                            localStorage.setItem("color", "light");
                                        } else {
                                            setColorState("dark");
                                            localStorage.setItem("color", "dark");
                                        }
                                    }}
                                />
                            </>
                        }
                        className={"headerDrawer"}
                        onClose={handleDrawerClose}
                        open={open}
                    >
                        <Row>
                            <Col span={10} className={"text-center"}>
                                <Avatar
                                    size={100}
                                    src={userDetails?.profileImage || dummyImg}
                                />
                                <div className={"flex justify-center items-center"}>
                                    <IconCommon
                                        iconName={"qr"}
                                        onClick={() => setOpenQrModal(true)}
                                        className={"mt-2 mx-2 qrIcon"}
                                    />
                                    <p
                                        className={"textColor mt-2 mb-0 mx-2 headerSpan cursor-pointer"}
                                        onClick={() => {
                                            navigate("/wallet-operations");
                                            handleDrawerClose();
                                        }}
                                    >
                                        {formatCurrency(eWalletSummary, true)}
                                    </p>
                                </div>
                            </Col>
                            <Col span={14}>
                                <p className={"textColor mb-2"}>
                                    {t("common.hello")}, <strong>{userDetails?.username}</strong>
                                </p>
                                <p className={"textColor mb-2"}>
                                    <strong>{t("user.rank")}:</strong> {userDetails?.rank?.name}
                                </p>
                                <p className={"textColor mb-2"}>
                                    <strong>{t("user.email")}:</strong> {userDetails?.email}
                                </p>
                                <p className={"textColor mb-2"}>
                                    <strong>{t("user.mobileNo")}:</strong>{" "}
                                    {userDetails?.completedMobileNo}
                                </p>
                            </Col>
                        </Row>
                        <Divider className={"dividerColor"}/>
                        <Row className={"buttons-row"}>
                            {userDetails?.clientAccountType === "demo" && (
                                <Button
                                    className={"platform_download secondary_btn"}
                                    onClick={() => setOpenGoLiveModal(true)}
                                >
                                    {t("common.goLive")}
                                </Button>
                            )}
                            <Button
                                className={"platform_download secondary_btn mt-2"}
                                onClick={() => setOpenPlatformModal(true)}
                                icon={<IconCommon className={"headerIcon"} iconName={"import"}/>}
                            >
                                {t("module.platformDownload")}
                            </Button>
                            <Button
                                className={"w-full mt-2 secondary_btn"}
                                onClick={() => {
                                    navigate("/wallet-withdrawal");
                                    handleDrawerClose();
                                }}
                                icon={<IconCommon className={"headerIcon"} iconName={"withdrawal"}/>}
                            >
                                {t("module.withdrawal")}
                            </Button>
                            <Button
                                className={"w-full primary_btn mt-2"}
                                onClick={() => {
                                    navigate("/wallet-deposit");
                                    handleDrawerClose();
                                }}
                                icon={<IconCommon className={"headerIcon"} iconName={"deposit"}/>}
                            >
                                {t("module.deposit")}
                            </Button>
                        </Row>
                        <Row className={"text-center toBottom"}>
                            <Col span={12}>
                                <Button
                                    type={"link"}
                                    onClick={() => {
                                        navigate("/profile");
                                        handleDrawerClose();
                                    }}
                                    icon={<IconCommon className={"headerIcon"} iconName={"edit"}/>}
                                >
                                    {t("common.editProfile")}
                                </Button>
                            </Col>
                            <Col span={12}>
                                <Button
                                    type={"link"}
                                    onClick={() => {
                                        handleDrawerClose();
                                        handleTokenExpiration(true);
                                    }}
                                    icon={<IconCommon className={"headerIcon"} iconName={"logout"}/>}
                                >
                                    {t("common.logOut")}
                                </Button>
                            </Col>
                        </Row>
                    </Drawer>
                </>
            ) : (
                <Row className={"justify-between items-center"}>
                    <Col className={"p-0"}>
                        <img
                            alt={"logo"}
                            className={"cursor-pointer h-[37px]"}
                            onClick={() => navigate("/dashboard")}
                            style={{marginLeft: "0.5rem"}}
                            src={colorState === "dark" ? brandSettingState?.companyLogoInverse : brandSettingState?.companyLogo}
                        />
                    </Col>
                    <Col className={"text-center flex items-center justify-end px-2"}>
                        {userDetails?.clientAccountType === "demo" && (
                            <>
                                <Button onClick={() => setOpenGoLiveModal(true)}>
                                    {t("common.goLive")}
                                </Button>
                                <Divider type={"vertical"} className={"headerDivider"}/>
                            </>
                        )}
                        <Button
                            className={"platform_download"}
                            onClick={() => setOpenPlatformModal(true)}
                        >
                            <DownloadOutlined style={{margin: "0", verticalAlign: "2px", color: "var(--primary-btn-bg-color)"}}/>
                            {t("module.platformDownload")}
                        </Button>
                        <Divider type={"vertical"} className={"headerDivider"}/>
                        <Dropdown
                            overlay={dropdownItems}
                            trigger={["click"]}
                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                        >
                            <a onClick={(e) => e?.preventDefault()} className={"profile-trigger"}>
                                <div className={"flex items-center justify-center"}>
                                    <Avatar
                                        size={32}
                                        src={userDetails?.profileImage || dummyImg}
                                        style={{marginRight: "0.75rem"}}
                                    />
                                    <span className={"headerSpan"}>{userDetails?.username}</span>
                                </div>
                            </a>
                        </Dropdown>
                        <Divider type={"vertical"} className={"headerDivider"}/>
                        <Dropdown
                            trigger={["click"]}
                            overlay={<Announcement_2 isHeader/>}
                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                            placement={"bottom"}
                        >
                            <div className={"header-announcement"}>
                                <Badge count={unreadAnnouncementCount + unreadPushNotificationCount} size={"small"}>
                                    <IconCommon
                                        className={"sidebarIcon cursor-pointer"}
                                        iconName={"alert"}
                                    />
                                </Badge>
                            </div>
                        </Dropdown>
                        <Divider type={"vertical"} className={"headerDivider"}/>
                        <span
                            className={"headerSpan cursor-pointer"}
                            onClick={() => navigate("/wallet-operations")}
                        >
                            {formatCurrency(eWalletSummary, true)}
                        </span>
                        <Divider type={"vertical"} className={"headerDivider"}/>
                        <IconCommon
                            className={"sidebarIcon cursor-pointer"}
                            iconName={"qr"}
                            onClick={() => setOpenQrModal(true)}
                        />
                        <Divider type={"vertical"} className={"headerDivider"}/>
                        <Dropdown
                            overlay={languageDropdown}
                            id={"language-select"}
                            getPopupContainer={(triggerNode) => triggerNode.parentElement}
                            arrow
                        >
                            <a className={"headerSpan"} onClick={(e) => e?.preventDefault()}>
                                {currentLanguageObj?.nativeName}
                            </a>
                        </Dropdown>
                        <Divider type={"vertical"} className={"headerDivider"}/>
                        <div>
                            <Switch
                                checked={colorState === "light"}
                                checkedChildren={
                                    <IconCommon
                                        iconName={"sun"}
                                        className={"size-4"}
                                        style={{filter: "brightness(.2) invert(1)"}}
                                    />
                                }
                                unCheckedChildren={<IconCommon iconName={"moon"} className={"size-4"}/>}
                                onChange={(e) => {
                                    if (e) {
                                        setColorState("light");
                                        localStorage.setItem("color", "light");
                                    } else {
                                        setColorState("dark");
                                        localStorage.setItem("color", "dark");
                                    }
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            )}
            <QrModal
                isModalOpen={openQrModal}
                handleCancel={() => setOpenQrModal(false)}
            />
            <PlatformDownloadModal
                isModalOpen={openPlatformModal}
                handleCancel={() => setOpenPlatformModal(false)}
                platformData={platformData}
            />
            <GoLiveModal
                isModalOpen={openGoLiveModal}
                handleCancel={() => setOpenGoLiveModal(false)}
                registerField={registerField}
            />
        </Header>
    );
};
